import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ScriptLoaderService } from '../../../shared/services/script-loader.service';

declare global {
  interface Window {
    _paq: ([string] | [string, string | number | boolean])[];
  }
}

@Injectable({ providedIn: 'root' })
export class MatomoLoaderService {
  private readonly loader = inject(ScriptLoaderService);
  private loaded = false;

  async init(): Promise<void> {
    if (this.loaded) return;
    this.loaded = true;
    const window = globalThis as unknown as Window;

    window._paq = window._paq || [];
    window._paq.push(
      ['setTrackerUrl', `${environment.matomo.url}matomo.php`],
      ['setSiteId', environment.matomo.siteId],
      ['requireConsent'],
    );

    await this.loader.load(`${environment.matomo.url}matomo.js`);
  }
}
